/* eslint-disable eqeqeq */
import React, { useContext, useEffect, useState, useRef } from "react";
// import material ui components
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

// import pages components
import GoSellElementsTrans from "../Pages/GoSell";
// import Axios for Fetching data from api
import Axios from "axios";
// import cookies functions
import { getCookie } from "../Functions/cookieFunction";
import { handleError } from "../Functions/getAlert";
import { useTranslation, withTranslation } from "react-i18next";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

// const DialogActions = withStyles((theme) => ({
//   root: {
//     margin: 0,
//     padding: theme.spacing(1),
//   },
// }))(MuiDialogActions);

 function CustomizedDialogs(props) {
  const {t} = useTranslation()
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [loading] = useState(false);
  const childRef = useRef();
  const [tapId, setTapId] = useState(undefined);
  const [payWith, setPayWith] = useState("");
  const [paymentValue, setPaymentValue] = useState(1.5);
  const [inpValue, setInpValue] = useState(1.5);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [seeMore, setSeeMore] = useState(1);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  // const handleClose = () => {
  //   setOpen(false);
  // };
  const handlChangeView = () => {
    if (appState.cardList.length > seeMore) {
      setSeeMore(seeMore + 1);
    } else {
      setSeeMore(1);
    }
  };
  useEffect(() => {
    setInpValue(paymentValue);
  }, [paymentValue]);

  const handlePaymentValue = (e) => {
    setPaymentValue(parseFloat(e.target.value));
  };
  const handleInpValue = (e) => {
    isNaN(parseFloat(e.target.value))
      ? setInpValue(0)
      : setInpValue(parseFloat(e.target.value));
  };
  const handlePay = (e) => {
    setPayWith(e.target.value);
  };

  const topUp = async () => {
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: true,
    });
    const token = {
      headers: {
        Authorization: `Bearer ${appState.token}`,
      },
    };
    if (payWith == "knet" ||  payWith == "card") {
      try { 
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/topup`,
          {
            amount: inpValue,
            payment_source: payWith,
            token: tapId ? tapId : null
          },
          token
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
        } else if (response.data.success == false) {
          props.setAlertMessage({
            open: true,
            message: `${response.data.message}:  ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } catch (e) {

        Promise.reject(e);
        handleError(e, appDispatch)
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    } else {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/topup`,
          {
            amount: inpValue,
            payment_source: "save_card",
            card_id: payWith,
          },
          token
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
        } else if (response.data.success == false) {
          props.setAlertMessage({
            open: true,
            message: `${response.data.message}:  ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } catch (e) {
        Promise.reject(e);
        handleError(e, appDispatch)
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  };
   
  const handleSubmit = (event) => {
    
    event.preventDefault();
    if (
      payWith != undefined &&
      payWith != "" &&
      payWith != null
      ) {
        if (payWith == "card") {
        if (tapId != undefined && tapId != "" && tapId != null) {
          topUp();
        } else {
          appDispatch({
            type: 'Set_FreezScreen',
            freezScreen: true
          })
          childRef.current.submitRequest();
        }
      }
      else{
          topUp();
      }
    } else {
      props.setAlertMessage({
        open: true,
        message: "Please select any payment method!",
        alertSuccess: false,
      });
    }
  };
  
  useEffect(() => {
    if (tapId != "" && tapId != undefined) {
      topUp();
    }
  }, [tapId]);
  
  useEffect(() => {
    setButtonLoading(false);
  }, [props.handleClose]);

  return (
    <>
      <div className={`dialogs`}>
        {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open dialog
      </Button> */}

        <Dialog
          fullWidth={true}
          aria-labelledby="customized-dialog-title"
          open={props.open}
        >
          <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
            {" "}
          </DialogTitle>
          <DialogContent>
            <div id="walletModal" className={`${buttonLoading ? "disableClass" : ""} `}>
              <div className="row mx-2 popUp-content">
                <h3>
                  {" "}
                  <strong>Balance</strong>{" "}
                </h3>
                {appState.loggedIn ? (
                  <h5>
                    {appState.profile.wallet
                      ? appState.profile.wallet.amount
                      : "0"}{" "}
                    {t("KWD")}
                  </h5>
                ) : (
                  <h5>{t("KWD")}</h5>
                )}
                <div className="row m-0 amount-head ">
                  <h4>Amount</h4>

                  <div className="popUp-amount p-0">
                    <OutlinedInput
                      id="standard-adornment-weight"
                      type="number"
                      // value={currentAmount}
                      // onChange={(e)=> {
                      //   setCurrentAmount(e.target.value)
                      // }}
                      style={{ textAlign: "center" }}
                      onChange={handleInpValue}
                      value={inpValue}
                      className="border-0 w-100 text-center amount-field hello"
                      endAdornment={
                        <InputAdornment position="end" className="text-muted">
                          {t("KWD")}
                        </InputAdornment>
                      }
                    />
                  </div>

                  <p className="py-2 m-0 text-muted">
                    Or quickly select amount
                  </p>
                  <div className="selectPayment">
                    <div
                      id="menuContainer"
                      role="group"
                      className="row m-0 menuContainer btn-group selectPaymentRow"
                      onChange={(e) => handlePaymentValue(e)}
                    >
                      <div className="d-flex">
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="10"
                              name="selectPayment"
                              id="paymentTwenty"
                            />
                            <label htmlFor="paymentTwenty">
                              <span>
                                <strong>10 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="20"
                              name="selectPayment"
                              id="paymentThirty"
                            />
                            <label htmlFor="paymentThirty">
                              <span>
                                <strong className="payment">20 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="30"
                              name="selectPayment"
                              id="paymentFourty"
                            />
                            <label htmlFor="paymentFourty">
                              <span>
                                <strong>30 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="40"
                              name="selectPayment"
                              id="paymentFifty"
                            />
                            <label htmlFor="paymentFifty">
                              <span>
                                <strong>40 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="50"
                              name="selectPayment"
                              id="paymentSixty"
                            />
                            <label htmlFor="paymentSixty">
                              <span>
                                <strong>50 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="60"
                              name="selectPayment"
                              id="paymentSeventy"
                            />
                            <label htmlFor="paymentSeventy">
                              <span>
                                <strong>60 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section
                id="paySelection"
                onChange={handlePay}
                className="topUpPayments"
              >
                {appState.loggedIn
                  ? appState.cardList != null
                    ? appState.cardList.slice(0, seeMore).map((val, ind) => {
                      return (
                        
                          <div className="mt-3 paymentContainer p-0">
                            <div>
                              <input
                                type="radio"
                                checked={payWith == val.id}
                                value={val.id}
                                name="payWith"
                                id={`paySaveCard-${val.id}`}
                                className="text-capitalize"
                              />

                              <label htmlFor={`paySaveCard-${val.id}`}>
                                <div className="row m-0 align-items-center">
                                  <span className="pl-3">
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                      alt=""
                                      width="30"
                                    />
                                  </span>
                                  <h5 className="mt-3 mx-4 text-capitalize">
                                    {val.type}
                                    <p className="text-muted saveCardNumber" >
                                      {" "}
                                      **** **** **** {val.last_four}
                                    </p>
                                  </h5>
                                </div>
                              </label>
                            </div>
                          </div>
                        );
                      })
                    : ""
                  : ""}

                {appState.loggedIn ? (
                  appState.cardList != null ? (
                    <div className="col-12 d-flex justify-content-end mb-2">
                      {appState.cardList.length > 1 && <Button
                        variant="text"
                        className="text-capitalize"
                        onClick={handlChangeView}
                      >
                        {seeMore < appState.cardList.length
                          ? "See More"
                          : "See Less"}
                      </Button>}
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                <div className="row">

                <div className="mt-3 col-6 paymentContainer ">
                  <div>
                    <input
                      type="radio"
                      checked={payWith == "knet"}
                      id="payKnet"
                      value="knet"
                      name="payWith"
                      defaultChecked
                    />

                    <label htmlFor="payKnet">
                      <div className="row m-0 align-items-center">
                        <span className="pl-3">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}Knet.png`}
                            alt=""
                            width="30"
                          />
                        </span>
                        <span className="pl-3">
                          <h6 className="mt-2">Knet</h6>
                          {/* <h6> 15 {t("KWD")}</h6> */}
                        </span>
                      </div>
                    </label>
                  </div>
                </div>

                <div className="mt-3 col-6 mb-2 paymentContainer ">
                  <div>
                    <input
                      type="radio"
                      checked={payWith == "card"}
                      value="card"
                      name="payWith"
                      id="payMaster"
                    />
                    <label htmlFor="payMaster">
                      <div className="row m-0 align-items-center">
                        <span className="pl-3">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                            alt=""
                            width="30"
                          />
                        </span>
                        <span className="pl-3">
                          <h6 className="mt-2"> Card</h6>
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
                </div>


                {payWith == "card" ? (
                  <div className="col-12 px-0">
                    <GoSellElementsTrans
                      ref={childRef}
                      inpValue={inpValue}
                      setTapId={setTapId}
                      payWith={payWith}
                      setButtonLoading={setButtonLoading}
                    />
                  </div>
                ) : (
                  ""
                )}
              </section>
              <section id="process-btn" className="row m-0">
                <Button
                  className="col-12  btn-main align-item-center justify-content-center"
                  disabled={buttonLoading}
                  // type="submit"
                  onClick={handleSubmit}
                >
                  {buttonLoading ? "Redirecting" : " Confirm and pay"}
                </Button>
              </section>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default withTranslation() (CustomizedDialogs)